import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div>
      <nav>{/* Add your navigation here if needed */}</nav>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
